import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocationComplianceCell } from '../../types/solution-participation-types';

@Component({
    selector: 'location-compliance-cell',
    templateUrl: './location-compliance-cell.component.html',
    styleUrls: ['./location-compliance-cell.component.scss'],
    standalone: false
})
export class LocationComplianceCellComponent implements OnInit {

  @Input() locationComplianceCell : LocationComplianceCell | undefined;
  compliance : string | undefined ;
  nonCompliance : string | undefined;
  complianceCount : string | number | undefined;
  nonComplianceCount : string | number | undefined; 

  @Output() onUsageClick: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.compliance = this.locationComplianceCell?.compliance;
    this.nonCompliance = this.locationComplianceCell?.nonCompliance;
    this.complianceCount = this.locationComplianceCell?.complianceCount;
    this.nonComplianceCount = this.locationComplianceCell?.nonComplianceCount;

    if(this.compliance && this.nonCompliance){
      this.compliance = parseFloat(this.compliance).toFixed(1);
      this.nonCompliance = parseFloat(this.nonCompliance).toFixed(1);
    }
  }

}
